import { useAppTheme } from "@hooks/useAppTheme";
import { smartPluralize } from "@memorang/helpers/common";
import Button from "@memorang/ui/components/Button";
import { useTranslation } from "react-i18next";
import { Dialog, Portal, Text } from "react-native-paper";

type Props = {
	visible: boolean;
	onDismiss: () => void;
	handleAction: (type: "positive" | "negative") => void;
	hasAnsweredAtLeastOneItem?: boolean;
	isDiagnostic?: boolean;
	numItemsLeft?: number;
};

const SessionEndDialog = ({
	visible,
	onDismiss,
	handleAction,
	hasAnsweredAtLeastOneItem,
	isDiagnostic,
	numItemsLeft,
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const subtitle = hasAnsweredAtLeastOneItem
		? t(
				isDiagnostic
					? "session.endDialog.confirmEndDiagnostic"
					: "session.endDialog.confirmEnd",
				{
					num: numItemsLeft,
					itemLabel: t(smartPluralize("item", numItemsLeft!)),
				},
			)
		: t("session.endDialog.confirmEndNoAnswer");

	return (
		<Portal>
			<Dialog
				visible={visible}
				onDismiss={onDismiss}
				style={{
					width: 350,
					alignSelf: "center",
				}}
			>
				<Dialog.Title>{t("session.endDialog.title")}</Dialog.Title>
				<Dialog.Content>
					<Text variant="bodyMedium">{subtitle}</Text>
				</Dialog.Content>
				<Dialog.Actions>
					<Button
						textColor={theme.colors.onSurfaceVariant}
						onPress={() => {
							handleAction("positive");
						}}
					>
						{t("session.endDialog.confirmEndNoAnswerNegative")}
					</Button>
					<Button
						textColor={theme.colors.primary}
						onPress={() => {
							handleAction("negative");
						}}
					>
						{t("session.endDialog.confirmEndNoAnswerPositive")}
					</Button>
				</Dialog.Actions>
			</Dialog>
		</Portal>
	);
};

export default SessionEndDialog;
